import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;

export default function OrderListHeader({ totalItem, onCollapse, collapsed }) {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="flex min-h-12 shrink-0 flex-wrap items-center justify-between space-x-2 border-b border-gray-800 pb-3">
      <Title level={4} className="m-0">
        {t('Order List')}
        <span className="ml-1">
          ({totalItem || 0} {t('items')})
        </span>
      </Title>
      <Button
        className={`batch-button flex items-center justify-center text-base`}
        size="small"
        onClick={() => onCollapse()}
        style={{ width: 90 }}
      >
        {collapsed ? t('Expand') : t('Collapse')}
      </Button>
    </div>
  );
}
